import { render, staticRenderFns } from "./Editcoupon.vue?vue&type=template&id=3afa3518&scoped=true&"
import script from "./Editcoupon.vue?vue&type=script&lang=js&"
export * from "./Editcoupon.vue?vue&type=script&lang=js&"
import style0 from "./Editcoupon.vue?vue&type=style&index=0&id=3afa3518&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afa3518",
  null
  
)

export default component.exports